import debounce from 'debounce';
import * as Popper from "@popperjs/core"
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tab from 'bootstrap/js/dist/tab';
import collapse from 'bootstrap/js/dist/collapse';

// example importing other Bootstrap Javascript Module
import Modal from 'bootstrap/js/dist/modal';

// -----------------------------------------
// FUNCTIONS -- start
// -----------------------------------------

function select($target) {
    return document.querySelector($target);
}

function selectAll($target) {
    return document.querySelectorAll($target);
}

function initStickyNavbar() {
    window.addEventListener('scroll', debounce( () => {
        stickyNavbar();
    } ))
}

// -----------------------------------------
// FUNCTIONS -- end
// -----------------------------------------

// -----------------------------------------
// GSAP -- start
// -----------------------------------------

import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

/* The following plugin is a Club GSAP perk */
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);

let scrollSmootherEl;

function smootherInit() {
    scrollSmootherEl = ScrollSmoother.create({
        smooth: 1,
        effects: true,
        normalizeScroll: true
    });
}

function drga_fade_up() {
    const fadeUpElEl = gsap.utils.toArray('[data-drga="fade-up"]');
    fadeUpElEl.forEach( (el) => {
        gsap.fromTo(
            el, 
            {
                y: 100,
                autoAlpha: 0,
            },
            {
                y: 0,
                autoAlpha: 1,
                duration: 0.8,
                // ease: 'power1.out',
                scrollTrigger: {
                    trigger: el,
                    // markers: true,
                    start: 'top-=200 75%'
                }
            }
        );
    } );
}

function footerReveal() {
    ScrollTrigger.create({
        trigger: ".footer",
        pin: true,
        start: "bottom bottom",
        end: "+=100%"
    })
}

function scrollToFunction($target) {
    gsap.to(
        window,
        {
            duration: 0.8,
            scrollTo: $target
        }
    );
}

// -----------------------------------------
// GSAP -- end
// -----------------------------------------

// -----------------------------------------
// PAGE LOAD -- start
// -----------------------------------------

function isLoaded() {

    document.addEventListener('DOMContentLoaded', () => {

        select('body').classList.remove('loading')

        gsap.to('.loading-container', {
            height: 0,
            display: 'none',
            // autoAlpha: 0,
            duration: 1
        })
    })

}

// -----------------------------------------
// PAGE LOAD -- end
// -----------------------------------------

// -----------------------------------------
// NAVBAR -- start
// -----------------------------------------

export const navbarHeight = select('.makanplace-navbar')?.offsetHeight ?? 0;

function stickyNavbar() {

    const windowLocation = window.scrollY;

    if ( windowLocation > 50 ) {
        select('.makanplace-navbar').classList.add('sticky')
    } else {
        select('.makanplace-navbar').classList.remove('sticky')
    }

}

// -----------------------------------------
// NAVBAR -- end
// -----------------------------------------

// -----------------------------------------
// FLOATING BUTTON -- start
// -----------------------------------------

// function showFloatingButton() {

//     const windowLocation = window.scrollY;

//     if ( windowLocation > 50 ) {
//         select('.floating-button').classList.add('show')
//     } else {
//         select('.floating-button').classList.remove('show')
//     }
// }

// -----------------------------------------
// FLOATING BUTTON -- end
// -----------------------------------------

// -----------------------------------------
// EXECUTE -- start
// -----------------------------------------

window.addEventListener('load', () => {

    const loadedWinWidth = window.innerWidth;
    
    if ( window.innerWidth >= 992 ) {
        smootherInit();
        // footerReveal();
    }

    window.addEventListener('resize', debounce(() => {
        const currentWinWidth = window.innerWidth;
        if ( currentWinWidth != loadedWinWidth ) {
            location.reload();
        }
    }))

    // --------------------------------------------------
    // Fade Up Animation -- start
    // --------------------------------------------------

    drga_fade_up();

    // --------------------------------------------------
    // Fade Up Animation -- End
    // --------------------------------------------------

    // --------------------------------------------------
    // Anchor Link JavaScript -- start
    // --------------------------------------------------

    selectAll('.anchor-link a').forEach( (item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToFunction( item.attributes['href'].value)
        })
    } )

    // --------------------------------------------------
    // Anchor Link JavaScript -- End
    // --------------------------------------------------

    // --------------------------------------------------
    // Close Menu When Clicked -- start
    // --------------------------------------------------

    if ( window.innerWidth <= 991 ) {
        selectAll('.navbar-collapse a').forEach( (item) => {
            item.addEventListener('click', () => {
                const navbar = new collapse('.navbar-collapse');
                navbar.hide
            })
        } )
    }

    // --------------------------------------------------
    // Close Menu When Clicked -- End
    // --------------------------------------------------

    // --------------------------------------------------
    // add backdrop to navbar collapse -- start
    // --------------------------------------------------

    const navbarCollapse = select('.navbar-collapse')
    const navbarBackdrop = select('.makanplace-navbar-backdrop')

    navbarCollapse.addEventListener('show.bs.collapse', () => {
        select('body').style.overflow = 'hidden';
        select('body').style.paddingRight = '15px';
        gsap.to(
            navbarBackdrop,
            {
                autoAlpha: 0.5,
                duration: 0.3
            }
        )
    })

    navbarCollapse.addEventListener('hide.bs.collapse', () => {
        select('body').style.overflow = 'auto';
        select('body').style.paddingRight = '0';
        gsap.to(
            navbarBackdrop,
            {
                autoAlpha: 0,
                duration: 0.3
            }
        )
    })

    // --------------------------------------------------
    // add backdrop to navbar collapse -- end
    // --------------------------------------------------

})

// -----------------------------------------
// EXECUTE -- end
// -----------------------------------------

// -----------------------------------------
// EXPORT -- start
// -----------------------------------------

isLoaded();

export { select, selectAll, initStickyNavbar, gsap, ScrollTrigger, smootherInit, scrollSmootherEl, drga_fade_up, scrollToFunction, isLoaded, footerReveal, stickyNavbar }

// -----------------------------------------
// EXPORT -- end
// -----------------------------------------

